import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Blog";

const QUERY_BLOG_DETAIL = gql`
  query blog($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}:blog(uid: $uid, lang:$lang) {
      title
      feature_image
      description
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_BLOG_DETAIL };
